// Role suggestions surfaced as chips in the Tambah Server / Edit Server
// modals. Region is no longer a fixed list — operators get a geo-IP auto-
// suggestion from ipwho.is and can free-form override.
export const ROLES = [
  { tag: "web", prefix: "web", baseCpu: 35, baseRam: 60, baseDisk: 40 },
  { tag: "api", prefix: "api", baseCpu: 45, baseRam: 65, baseDisk: 35 },
  { tag: "db", prefix: "db", baseCpu: 55, baseRam: 78, baseDisk: 72 },
  { tag: "cache", prefix: "cache", baseCpu: 30, baseRam: 85, baseDisk: 22 },
  { tag: "worker", prefix: "worker", baseCpu: 62, baseRam: 55, baseDisk: 28 },
  { tag: "queue", prefix: "queue", baseCpu: 22, baseRam: 48, baseDisk: 18 },
  { tag: "lb", prefix: "lb", baseCpu: 18, baseRam: 32, baseDisk: 12 },
  { tag: "log", prefix: "log", baseCpu: 28, baseRam: 50, baseDisk: 88 },
  { tag: "build", prefix: "ci-runner", baseCpu: 70, baseRam: 70, baseDisk: 55 },
];

// A server is "offline" if its last contact is older than this many ms.
// Default tick is 3s, so 3 missed ticks = ~9s. We give a wider window to
// tolerate transient network blips.
export const OFFLINE_THRESHOLD_MS = 30_000;

// How many points to keep in the in-memory sparkline ring buffer per server.
export const HISTORY_LENGTH = 30;
